import React from 'react';
import { VirtualTabContextProvider } from './VirtualTabContext';
import VirtualTabLayout from './VirtualTabLayout';

const VirtualTab: React.FC = () => (
    <VirtualTabContextProvider>
      <VirtualTabLayout />
    </VirtualTabContextProvider>
  );

export default VirtualTab;
